import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import moment from 'moment';
import Button from '../../../components/button/index';
import css from '../index.scss';
import messages from '../messages';
import {
    GOLD_CERTIFICATE_TYPE,
    SILVER_CERTIFICATE_TYPE,
    BRONZE_CERTIFICATE_TYPE,
    LONG_DATE_FORMAT,
    SHORT_DATE_FORMAT
} from '../../../containers/download-certificates/constants';
import { Download } from '../../../helpers/icon-dictionary';

const CertificatesTypes = (props) => {
    const {
        currentDate,
        fetchingSummarySuccess,
        downloadCertificates,
        isDownloading,
        summary
    } = props;

    const {
        startDate,
        endDate
    } = currentDate;

    const {
        goldCount, silverCount, bronzeCount
    } = summary;

    const dates = {
        startDate: moment(startDate, SHORT_DATE_FORMAT).format(LONG_DATE_FORMAT),
        endDate: moment(endDate, SHORT_DATE_FORMAT).format(LONG_DATE_FORMAT)
    };

    const hasDates = (startDate !== null || endDate !== null);

    const view = hasDates ? (<div className={css.certificatesSummaryContainer}>
        <div className={css.certificatesSummaryHeader}>
            {props.intl.formatMessage(messages.startToEndDateLabel, dates)}
        </div>
        <div className={css.certificatesSummaryColumn}>
            <div>{props.intl.formatMessage(messages.goldCertType)}</div>
            <Button
                containerClassName={css.certificatesSummaryButton}
                disabled={!fetchingSummarySuccess || goldCount === 0 || isDownloading}
                handleOnClick={() => downloadCertificates(GOLD_CERTIFICATE_TYPE)}
                icon={Download}
                iconClassName={css.icon}
                label={`${goldCount}`} />
        </div>
        <div className={css.certificatesSummaryColumn}>
            <div>{props.intl.formatMessage(messages.silverCertType)}</div>
            <Button
                containerClassName={css.certificatesSummaryButton}
                disabled={!fetchingSummarySuccess || silverCount === 0 || isDownloading}
                handleOnClick={() => downloadCertificates(SILVER_CERTIFICATE_TYPE)}
                icon={Download}
                iconClassName={css.icon}
                label={`${silverCount}`} />
        </div>
        <div className={css.certificatesSummaryColumn}>
            <div>{props.intl.formatMessage(messages.bronzeCertType)}</div>
            <Button
                containerClassName={css.certificatesSummaryButton}
                disabled={!fetchingSummarySuccess || bronzeCount === 0 || isDownloading}
                handleOnClick={() => downloadCertificates(BRONZE_CERTIFICATE_TYPE)}
                icon={Download}
                iconClassName={css.icon}
                label={`${bronzeCount}`} />
        </div>
    </div>) : (<div className={css.certificatesSummaryContainer} />);

    return view;
};

CertificatesTypes.propTypes = {
    currentDate: PropTypes.object,
    downloadCertificates: PropTypes.func,
    fetchingSummarySuccess: PropTypes.bool,
    intl: intlShape.isRequired,
    isDownloading: PropTypes.bool,
    summary: PropTypes.object
};

export default injectIntl(styleable(css)(CertificatesTypes));



// WEBPACK FOOTER //
// ./app/components/download-certificates/components/certificate-summary.js